(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Custom-Subscription-Widget"] && !Shopify.designMode) return;
  try {
    
  class SubscriptionWidget extends HTMLElement {
    connectedCallback() {
      this.cards = this.querySelectorAll('[data-plan-type]');
      this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');
      this.ctaButton = this.querySelector('[data-add-to-cart]');

      for (const card of this.cards) {
        card.addEventListener('click', () => this.#selectPlan(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.#selectPlan(card);
          }
        });
      }

      /* Default to 90-day */
      const defaultCard = this.querySelector('[data-plan-type="90-day"]');
      if (defaultCard) {
        this.#selectPlan(defaultCard);
      }
    }

    #selectPlan(selectedCard) {
      for (const card of this.cards) {
        card.setAttribute('aria-checked', 'false');
        const radio = card.querySelector('.sub-widget__radio');
        if (radio) {
          radio.classList.remove('sub-widget__radio--checked');
        }
      }

      selectedCard.setAttribute('aria-checked', 'true');
      const radio = selectedCard.querySelector('.sub-widget__radio');
      if (radio) {
        radio.classList.add('sub-widget__radio--checked');
      }

      const planId = selectedCard.dataset.sellingPlanId;
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = planId || '';
      }

      /* Dispatch event for the product form */
      this.dispatchEvent(new CustomEvent('subscription:plan-changed', {
        detail: {
          sellingPlanId: planId || null,
          planType: selectedCard.dataset.planType
        },
        bubbles: true
      }));
    }
  }

  if (!customElements.get('subscription-widget')) {
    customElements.define('subscription-widget', SubscriptionWidget);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carbon-landing"] && !Shopify.designMode) return;
  try {
    
  /* ─── SMOOTH SCROLL FOR CTA LINKS ─── */
  /* Handles scrolling to the native Shopify product section */
  document.querySelectorAll('.cl a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const targetId = link.getAttribute('href').slice(1);
      const target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carbon-preworkout-listicle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.getElementById('carbonStickyBar');
    if (!bar) return;
    var shown = false;
    window.addEventListener('scroll', function() {
      var scrolled = window.scrollY || window.pageYOffset;
      if (scrolled > 400 && !shown) {
        bar.classList.add('is-visible');
        shown = true;
      } else if (scrolled <= 400 && shown) {
        bar.classList.remove('is-visible');
        shown = false;
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-lander"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sticky = document.getElementById('tl-sticky');
    var hero = document.getElementById('tl-hero');
    if (!sticky || !hero) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          var heroBottom = hero.getBoundingClientRect().bottom;
          if (heroBottom < 0) {
            sticky.classList.add('tl-sticky--visible');
          } else {
            sticky.classList.remove('tl-sticky--visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tl-visible');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.tl-fade').forEach(function(el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
